import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { legacyMatchPath, withRouterLegacy } from 'core/routerUtils';
import { withTranslation } from 'react-i18next';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { placePathParams } from 'shared/helpers';
import { isEmpty } from 'lodash';
import './EventNavbar.scss';
import { PermissionsService } from 'shared/services';
import * as tcEventActions from 'features/tc-event-dashboard/duck';

const allowedPages = [
  {
    label: 'eventNavigation.roomsDashboard',
    path: '/test-event/:eventId/rooms-dashboard',
    permission: null,
  },
  {
    label: 'eventNavigation.testMaterials',
    path: '/test-event/:eventId/test-materials',
    permission: 'testCenterEventMaterialManage',
  },
];

const checkPath = (pathname, path) => {
  return legacyMatchPath(pathname, {
    path: path,
    exact: true,
    strict: false,
  });
};

class EventNavbar extends Component {
  constructor(props) {
    super(props);

    this.redirectPage = this.redirectPage.bind(this);
  }

  redirectPage(elem, eventId) {
    this.props.history.replace(placePathParams(elem, { eventId: eventId }));
  }

  render() {
    let eventIdParam, match;
    let pages = [];
    let className = 'event-navbar-container';

    if (
      allowedPages.some((el) => {
        match = checkPath(this.props.history.location.pathname, el.path);
        return !isEmpty(match);
      })
    ) {
      pages = allowedPages.filter((page) => {
        return (
          isEmpty(page.permission) ||
          PermissionsService.hasTestCenterManage(this.props.tcEvent.testCenterCycleId) ||
          PermissionsService.hasAccessTo(page.permission, 'testEvents', match.params.eventId)
        );
      });

      if (pages.length > 1) {
        eventIdParam = match.params.eventId;
      } else {
        className = 'd-none';
      }
    } else {
      className = 'd-none';
    }

    return (
      <div className={className}>
        <div className="container">
          <Scrollbars className="scrollbar">
            <nav className="Subnavbar">
              {pages.map((allowed) => (
                <div
                  key={allowed.label}
                  className={`${
                    checkPath(this.props.history.location.pathname, allowed.path) ? 'active' : ''
                  } div-link`}
                  onClick={() => this.redirectPage(allowed.path, eventIdParam)}>
                  {this.props.t(allowed.label)}
                </div>
              ))}
            </nav>
          </Scrollbars>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    tcEvent: state.tcEvent.currentEvent || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...tcEventActions,
      },
      dispatch
    ),
  };
}

EventNavbar.propTypes = {
  t: PropTypes.func.isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }),
  tcEvent: PropTypes.shape({
    testCenterCycleId: PropTypes.number,
  }),
  actions: PropTypes.shape({}),
};

export default withTranslation()(
  withRouterLegacy(connect(mapStateToProps, mapDispatchToProps)(EventNavbar))
);
